import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = a0 => ({
  "width.%": a0
});
const _c1 = () => ({
  "width.%": 100
});
function ProgressBarComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", ctx_r0.progress ? ctx_r0.progress <= 100 ? i0.ɵɵpureFunction1(1, _c0, ctx_r0.progress) : i0.ɵɵpureFunction0(3, _c1) : null);
  }
}
class ProgressBarComponent {
  constructor() {
    this.progress = 0;
  }
  static {
    this.ɵfac = function ProgressBarComponent_Factory(t) {
      return new (t || ProgressBarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProgressBarComponent,
      selectors: [["sol-progress-bar"]],
      inputs: {
        progress: "progress"
      },
      decls: 2,
      vars: 1,
      consts: [[1, "sol-progress-bar-determinate"], ["class", "sol-progress-bar-fill", 3, "ngStyle", 4, "ngIf"], [1, "sol-progress-bar-fill", 3, "ngStyle"]],
      template: function ProgressBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, ProgressBarComponent_div_1_Template, 1, 4, "div", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.progress);
        }
      },
      dependencies: [i1.NgIf, i1.NgStyle],
      styles: [".sol-progress-bar-determinate{height:.5rem;width:100%;min-width:4rem;border-radius:.25rem;background:var(--color-interface-background125);outline:.063rem solid var(--color-interface-blue550)}.sol-progress-bar-determinate .sol-progress-bar-fill{background:var(--color-interface-blue550);height:.5rem;border-radius:.25rem}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressBarComponent, [{
    type: Component,
    args: [{
      selector: 'sol-progress-bar',
      template: `
    <div class="sol-progress-bar-determinate">
      <div
        *ngIf="progress"
        class="sol-progress-bar-fill"
        [ngStyle]="progress ? (progress <= 100 ? { 'width.%': progress } : { 'width.%': 100 }) : null"
      ></div>
    </div>
  `,
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      styles: [".sol-progress-bar-determinate{height:.5rem;width:100%;min-width:4rem;border-radius:.25rem;background:var(--color-interface-background125);outline:.063rem solid var(--color-interface-blue550)}.sol-progress-bar-determinate .sol-progress-bar-fill{background:var(--color-interface-blue550);height:.5rem;border-radius:.25rem}\n"]
    }]
  }], null, {
    progress: [{
      type: Input
    }]
  });
})();
class ProgressBarModule {
  static {
    this.ɵfac = function ProgressBarModule_Factory(t) {
      return new (t || ProgressBarModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProgressBarModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressBarModule, [{
    type: NgModule,
    args: [{
      declarations: [ProgressBarComponent],
      imports: [CommonModule],
      exports: [ProgressBarComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ProgressBarComponent, ProgressBarModule };
